module.exports = __webpack_public_path__ + "img/Malaysia.cab37729.svg";